import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of, Observable, firstValueFrom } from 'rxjs';
import { constant } from '../helpers/constant';
import { CookieService } from 'ngx-cookie-service';
import  data from '../../../../app/config.json';
import Utils from 'app/Utils';

declare let apiBaseUrl: string;
declare let faroUrl: string;

interface Config {
    APIUrl: string;
  }

@Injectable()
export class ApiService {
    private _baseUrl: string;
    private _faroUrl: string;
    public currentUser: any;
    public authorization: any;
    public _baseUrl1: string;
    public _config:any;
    constructor(private http: HttpClient, private cookieService: CookieService) {
        this._faroUrl = '';
        if (localStorage.getItem('currentUser')) {
          this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        }else{
            this.currentUser = null;
        }
         this._baseUrl = data.APIUrl;
    }

    async setBaseUrl() {
        // Conviertes el Observable a Promesa usando firstValueFrom
        const config: Config = await firstValueFrom(this.getJSON());
        if (config && config.APIUrl) {
          this._baseUrl = config.APIUrl;
          localStorage.setItem('baseURL', config.APIUrl);
        }
      }

    private getJSON() {
        return this.http.get<Config>('app/config.json');
      }
   
    setAuthorization(currentUser): void {
        this.authorization = {};
        if (currentUser != null) {
            this.authorization.Authorization = `Bearer ${currentUser.token}`;
        }
    }

    get(url: string) {
        if(this._baseUrl==undefined)
        {
            this._baseUrl=localStorage.getItem('baseURL');
        }
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser')));
        this.setAuthorization(this.currentUser);

        if (this.setAuthorization != null) {
            let headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': this._baseUrl
            });
            if (this.authorization != null) {
                headers = Object.assign(this.authorization);
            }

            const options = { headers: headers };

            const uri = this._baseUrl + url;
            return this.http
                .get(uri, options)
                .pipe(map(response =>
                    response
                ), catchError(err => of(err)));
            // }

        }
    }



    post(url: string, data?: any, mapJson: boolean = true, header?: any) { 
        if(this._baseUrl==undefined)
        {
            this._baseUrl=localStorage.getItem('baseURL');
        }
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser')));
        this.setAuthorization(this.currentUser);

        let initialHeader = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this._baseUrl
        }

        if (header) {
            initialHeader = Object.assign(initialHeader, header);
        }
        initialHeader = Object.assign(initialHeader, this.authorization);

        const headers = new HttpHeaders(initialHeader);

        const options = { headers: headers, observe: 'response' as const };

        if (mapJson) {
            return this.http.post(this._baseUrl + url, data, options)
                .pipe(map(response => <any>response.body));
        } else {
            return this.http.post(this._baseUrl + url, data, options);
        }
    }


    delete(url: string) {
        if(this._baseUrl==undefined)
        {
            this._baseUrl=localStorage.getItem('baseURL');
        }
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser')));;
        this.setAuthorization(this.currentUser);

        let initialHeader = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this._baseUrl
        }
        initialHeader = Object.assign(initialHeader, this.authorization);
        const headers = new HttpHeaders(initialHeader);
        const options = { headers: headers };
        return this.http.delete(this._baseUrl + url, options)
            .pipe(map(response => <any>(response)), catchError(err => of('error2')));
    }


    put(url: string, data?: any, mapJson: boolean = true) {
        if(this._baseUrl==undefined)
        {
            this._baseUrl=localStorage.getItem('baseURL');
        }
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser')));;
        this.setAuthorization(this.currentUser);

        if (this.authorization !== null) {
            let headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': this._baseUrl
            });
            headers = Object.assign(this.authorization);

            const options = ({ headers: headers });
            if (url.charAt(0) !== '/' && this._baseUrl.charAt(this._baseUrl.length - 1) !== '/') {
                url = '/' + url;
            }
            return this.http.put(this._baseUrl + url, data, options)            
                .pipe(
                    map(response => response),
                    catchError(err => of(err))
                );
        }
    }


}
